export const CONTACTS_ROUTE = "/contacts";
